import {
  createService,
  getAllServices,
  getServiceById,
  updateServiceById,
  deleteServiceById,
} from 'api/admin/services';
import { getAllServices as getAllServicesByCustomer } from 'api/customer/services';

import { useEffect } from 'react';

import { useSnackbar } from 'notistack';
import { useMutation, useQuery, useQueryClient } from 'react-query';

function useCreateService() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(createService, {
    onError: (err) =>
      enqueueSnackbar(
        err.response && err.response.data.message ? err.response.data.message : err.message,
        { variant: 'error' }
      ),
    onSuccess: () => enqueueSnackbar('سرویس جدید با موفقیت ثبت شد.', { variant: 'success' }),
  });
}

function useAllServices(limit, page, query, dId) {
  return useQuery(
    ['services', page, query, "all"],
    () => getAllServices(limit, page, query, dId === "all" ? null : dId),
    {
      // keepPreviousData: true, just for pagination
      // enabled: !!dId,
      enabled: true,
    }
  );
}

// function useAllServicesByCustomer(limit, page, query, dId) {
//   return useQuery(
//     ['services', page, query, dId],
//     () => getAllServicesByCustomer(limit, page, query, dId),
//     {
//       // keepPreviousData: true, just for pagination
//       enabled: !!dId,
//     }
//   );
// }

function useAllServicesByCustomer(limit, page) {
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation(
    ({dId,query}) => getAllServicesByCustomer(limit, page, query, dId),
    {
      onError: (err) => {
        enqueueSnackbar(
          err.response && err.response.data.message ? err.response.data.message : err.message,
          { variant: 'error' }
        );
      },
      onSuccess: () => {
      },
    }
  )

  return mutation;
}


function useService(id) {
  return useQuery(['service', id], () => getServiceById(id));
}

function useUpdateService() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation(updateServiceById, {
    onError: (err) =>
      enqueueSnackbar(
        err.response && err.response.data.message ? err.response.data.message : err.message,
        { variant: 'error' }
      ),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries(['service', id]);
      enqueueSnackbar('سرویس با موفقیت ویرایش شد', { variant: 'success' });
    },
  });
}

function useDeleteService() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation(deleteServiceById, {
    onError: (err) =>
      enqueueSnackbar(
        err.response && err.response.data.message ? err.response.data.message : err.message,
        { variant: 'error' }
      ),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries(['service', id]);
      enqueueSnackbar('سرویس مورد نظر حذف شد', { variant: 'success' });
    },
  });
}

export { useCreateService, useAllServices, useAllServicesByCustomer, useService, useUpdateService, useDeleteService };
